import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ROUTES } from "@/constants/routes";
import { useAuthStore } from "@/store";

export function RequireAuth() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isSessionValid = useAuthStore((state) => state.isSessionValid);
  const logout = useAuthStore((state) => state.logout);
  const location = useLocation();

  const sessionOk = isAuthenticated && isSessionValid();

  useEffect(() => {
    if (isAuthenticated && !isSessionValid()) {
      logout({ redirect: true });
    }
  }, [isAuthenticated, isSessionValid, logout]);

  if (!sessionOk) {
    return <Navigate to={ROUTES.login} replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
